const toRadians = (degrees) => degrees * Math.PI / 180
export default toRadians



// WEBPACK FOOTER //
// ./src/utils/toRadians.js